// extracted by mini-css-extract-plugin
export var actionText = "_j6-4";
export var container = "_j6-0";
export var leftSection = "_j6-1";
export var rightSection = "_j6-2";
export var settingsButton = "_j6-6";
export var settingsIcon = "_j6-7";
export var shortcut = "_j6-5";
export var shortcutGroup = "_j6-3";